// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3QS4L","rootSuccess":"CompleteLink_rootSuccess__1HSIV","rootFailure":"CompleteLink_rootFailure__Tbf6W","isDisabled":"CompleteLink_isDisabled__R-lMX"};